import type { AcknowledgementPayloadDTO } from "@/core/types";
import { patientRequestsTyped } from "@/api/patientTyped";

const params = { showLoader: false };

export async function appendAcknowledgement(data: AcknowledgementPayloadDTO) {
  return patientRequestsTyped.append_acknowledgement({ data, params });
}
